import './Hero.css';
import { Simbolo } from '../Logo/Logo';
import { IconeSeta } from '../Icones/Icones';

// Alturas das barras do gráfico ilustrativo (apenas decoração, sem dados reais).
const BARRAS = [48, 64, 56, 78, 70, 88, 82];

function Hero() {
    return (
        <section id="inicio" className="hero">
            <Simbolo className="hero-simbolo-fundo" />

            <div className="container hero-conteudo">
                <div className="hero-texto">
                    <span className="hero-rotulo">Software sob medida · Produtos próprios</span>
                    <h1 className="hero-titulo">
                        Software com o <span className="hero-destaque">formato</span> da sua operação.
                    </h1>
                    <p className="hero-descricao">
                        A C1010 desenvolve sistemas sob medida para empresas que não cabem em planilha
                        nem em software de prateleira. E transforma o que funciona em produto.
                    </p>
                    <div className="hero-acoes">
                        <a href="#sistemas" className="btn btn-primario">
                            Conheça nossos sistemas
                            <IconeSeta tamanho={18} />
                        </a>
                        <a href="#contato" className="btn btn-contorno-claro">Tenho um projeto</a>
                    </div>
                    <ul className="hero-produtos" aria-label="Produtos da C1010">
                        <li><span className="ponto ponto-torque" />Torque <small>para oficinas mecânicas</small></li>
                        <li><span className="ponto ponto-transp" />Gerenciador de Transportes <small>para transportadoras</small></li>
                    </ul>
                </div>

                <div className="hero-visual" aria-hidden="true">
                    <div className="janela janela-transp">
                        <div className="janela-barra">
                            <span /><span /><span />
                            <strong>Gerenciador de Transportes</strong>
                        </div>
                        <div className="janela-corpo">
                            <div className="janela-linha-titulo">
                                <p>Pontualidade das cargas</p>
                                <i className="esqueleto curto" />
                            </div>
                            <div className="janela-cartoes">
                                <div><p>Embarques</p><i className="esqueleto" /></div>
                                <div><p>Projeção financeira</p><i className="esqueleto" /></div>
                            </div>
                            <div className="grafico">
                                {BARRAS.map((altura, i) => (
                                    <span key={i} style={{ '--altura': `${altura}%`, '--i': i }} />
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="janela janela-torque">
                        <div className="janela-barra">
                            <span /><span /><span />
                            <strong>Torque</strong>
                        </div>
                        <div className="janela-corpo">
                            <p className="janela-subtitulo">Ordens de serviço</p>
                            <ul className="lista-os">
                                <li><i className="esqueleto" /><em className="status andamento">Em andamento</em></li>
                                <li><i className="esqueleto" /><em className="status aguardando">Aguardando peça</em></li>
                                <li><i className="esqueleto" /><em className="status pronto">Pronto</em></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;
